module.exports = __webpack_public_path__ + "static/img/production_05.a47e65e6.jpg";